import gql from 'graphql-tag';

import type { BriefStatus, BriefType } from 'src/data/brief';
import type { AiSuggestionMode } from 'src/data/generation';
import type { GenerationTool } from 'src/data/generationTool';
import { PROJECT_TYPE, type ProjectType } from 'src/data/project';
import { executeGqlMutation, type GqlCallVariables } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { BRIEF_FROM_LIST_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation ExtractBrief(
    $customerId: ID!
    $url: String!
    $briefType: String!
    $projectType: String!
    $generationTool: GenerationToolEnum
    $suggestionMode: String
  ) {
    extractBrief(
      customerId: $customerId
      url: $url
      briefType: $briefType
      projectType: $projectType
      generationTool: $generationTool
      suggestionMode: $suggestionMode
    ) {
      ...BriefFromList
    }
  }
  ${BRIEF_FROM_LIST_FRAGMENT}
`;

interface Variables extends GqlCallVariables {
  customerId: ID;
  url: string;
  briefType: BriefType;
  generationTool?: GenerationTool;
  suggestionMode?: AiSuggestionMode;
  projectType?: ProjectType;
}

interface ResultItem {
  id: ID;
  type: BriefType;
  status: BriefStatus;
  errors?: string; // JSON
}

export const extractBrief = async (variables: Variables): Promise<ResultItem | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      ...variables,
      projectType: variables.projectType || PROJECT_TYPE.document,
    },
  });

  return getSingleProp<ResultItem>(result.data);
};
